'use client'

import {
  Box,
  Center,
  Flex,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading, 
  Text,
  Card, 
  CardHeader,
  CardBody,
  CardFooter,
  Divider,
  Image
} from '@chakra-ui/react'
import { ReactNode } from 'react'
import { IoIosStats } from 'react-icons/io'
import { BiSolidPencil } from 'react-icons/bi'
import { BiSolidUserVoice } from 'react-icons/bi'
import { CheckCircleIcon } from '@chakra-ui/icons'
import { COLORS } from "../../../colors"
import FormModal from "./formModal"



export default function Elegirnos() {
  return (
    <Flex flexDirection={"column"} gap={2} align={"center"} justify={"center"} px={6} height={{ base: 'fit-content', lg: 800 }} py={{ base: 10, lg: 0 }} >
      <Heading textAlign={"center"} as="h2" size="xl" mt={20} mb={2} fontFamily={"Montserrat"}>
        ¿Por qué elegirnos?
      </Heading>
      <Flex p={8} flex={1} align={'top'} justify={'center'} flexDirection={{ base: "column", lg: "row" }} >
        <Card align='center' m={5} width={{ base: "90%", md: "300px" }}>
            <Image src="/enseñanza_personalizada.png" alt="Imagen" mt={3} boxSize="200px" />
            <CardHeader>
            <Heading fontFamily={"Montserrat"} size='md'>Enseñanza personalizada</Heading>
            </CardHeader>
            <CardBody>
            <Text fontFamily={"Montserrat"} align='center'>Somos una academia pequeña e íntima, donde cada alumno es especial y donde nuestro verdadero interés en relacionarnos con nuestros alumnos es la clave de nuestro éxito.</Text>
            </CardBody>
            <CardFooter>
            </CardFooter>
        </Card>
        <Card align='center' m={5} width={{ base: "90%", md: "300px" }} >
            <Image src="/flexibilidad.png" alt="Imagen" mt={3} boxSize="200px" />
            <CardHeader>
            <Heading size='md' fontFamily={"Montserrat"}>Flexibilidad</Heading>
            </CardHeader>
            <CardBody>
            <Text fontFamily={"Montserrat"} align='center'>Somos más flexibles que otras academias ya que intentamos adaptarnos a las necesidades de cada persona y grupo.</Text>
            </CardBody>
            <CardFooter>
            </CardFooter>
        </Card>
        <Card align='center' m={5} width={{ base: "90%", md: "300px" }}>
            <Image src="/exito.jpg" alt="Imagen" mt={3} boxSize="200px" />
            <CardHeader>
            <Heading  fontFamily={"Montserrat"} size='md'>Garantía de éxito</Heading>
            </CardHeader>
            <CardBody>
            <Text fontFamily={"Montserrat"} align='center'>Tenemos un 99% de éxito de aprobados en exámenes oficiales de Cambridge. </Text>
            </CardBody>
            <CardFooter>
            </CardFooter>
        </Card>
        </Flex>
    </Flex>
  )
}